import { differenceInDays } from 'date-fns'

export default (dateIn: string, dateOut: string): number => {
  const fechaIn = toRuralityDate().parseLegacyDate(dateIn)
  const fechaOut = toRuralityDate().parseLegacyDate(dateOut)

  return differenceInDays(fechaOut, fechaIn)
}
